webpackJsonp([274317620777949],{

/***/ 215:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  flex-grow: 1;\n  width: 100vw;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n'], ['\n  flex-grow: 1;\n  width: 100vw;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  max-width: 360px;\n  margin-left: ', ';\n  margin-right: ', ';\n\n  h3 {\n    color: #422B25;\n    font-size: 28px;\n    line-height: 32px;\n    font-weight: 600;\n    margin-bottom: 27px;\n  }\n\n  p {\n    line-height: 24px;\n  }\n'], ['\n  max-width: 360px;\n  margin-left: ', ';\n  margin-right: ', ';\n\n  h3 {\n    color: #422B25;\n    font-size: 28px;\n    line-height: 32px;\n    font-weight: 600;\n    margin-bottom: 27px;\n  }\n\n  p {\n    line-height: 24px;\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  margin-top: 108px;\n  margin-bottom: 108px;\n  justify-content: ', ';\n  align-items: center;\n'], ['\n  margin-top: 108px;\n  margin-bottom: 108px;\n  justify-content: ', ';\n  align-items: center;\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  flex: 1;\n  min-height: 450px;\n  background-image: ', ';\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: center right;\n'], ['\n  flex: 1;\n  min-height: 450px;\n  background-image: ', ';\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: center right;\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n  max-width: 600px;\n\n  h1 {\n    color: #422B25;\n    font-size: 32px;\n    line-height: 36px;\n    font-weight: 600;\n    margin-bottom: 36px;\n  }\n\n  h2 {\n    color: #787878;\n    font-size: 24px;\n    line-height: 32px;\n    font-weight: 300;\n    margin-top: 9px;\n  }\n\n  h3 {\n    color: #422B25;\n    font-size: 20px;\n    line-height: 32px;\n    font-weight: 600;\n    margin-top: 27px;\n    margin-bottom: 9px;\n  }\n\n  p {\n    line-height: 24px;\n    margin-bottom: 18px;\n  }\n'], ['\n  max-width: 600px;\n\n  h1 {\n    color: #422B25;\n    font-size: 32px;\n    line-height: 36px;\n    font-weight: 600;\n    margin-bottom: 36px;\n  }\n\n  h2 {\n    color: #787878;\n    font-size: 24px;\n    line-height: 32px;\n    font-weight: 300;\n    margin-top: 9px;\n  }\n\n  h3 {\n    color: #422B25;\n    font-size: 20px;\n    line-height: 32px;\n    font-weight: 600;\n    margin-top: 27px;\n    margin-bottom: 9px;\n  }\n\n  p {\n    line-height: 24px;\n    margin-bottom: 18px;\n  }\n']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  align-items: center;\n  margin: 12px 0 24px;\n  line-height: 20px;\n'], ['\n  display: flex;\n  align-items: center;\n  margin: 12px 0 24px;\n  line-height: 20px;\n']),
	    _templateObject7 = _taggedTemplateLiteralLoose(['\n  height: 60px;\n  width: 60px;\n  border-radius: 30px;\n  background-image: ', ';\n  background-size: cover;\n  margin-right: 20px;\n'], ['\n  height: 60px;\n  width: 60px;\n  border-radius: 30px;\n  background-image: ', ';\n  background-size: cover;\n  margin-right: 20px;\n']),
	    _templateObject8 = _taggedTemplateLiteralLoose(['\n  margin-bottom: 20px;\n  @media (max-width: 1120px) {\n    position: relative;\n    margin-left: 0;\n    margin-right: 0;\n    padding-bottom: 56.25%; /* 16:9 */\n    padding-top: 25px;\n    height: 0;\n    iframe {\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n    }\n  }\n'], ['\n  margin-bottom: 20px;\n  @media (max-width: 1120px) {\n    position: relative;\n    margin-left: 0;\n    margin-right: 0;\n    padding-bottom: 56.25%; /* 16:9 */\n    padding-top: 25px;\n    height: 0;\n    iframe {\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n    }\n  }\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(9);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactHelmet = __webpack_require__(21);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Grid = __webpack_require__(16);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _gatsbyLink = __webpack_require__(26);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _authorMike = __webpack_require__(55);
	
	var _authorMike2 = _interopRequireDefault(_authorMike);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Wrapper = _styledComponents2.default.div(_templateObject);
	
	var SectionContent = _styledComponents2.default.div(_templateObject2, function (props) {
	  return props.right ? '80px' : null;
	}, function (props) {
	  return props.left ? '80px' : null;
	});
	
	var Section = (0, _styledComponents2.default)(_Grid2.default.Container)(_templateObject3, function (props) {
	  return props.right ? 'flex-end' : 'flex-start';
	});
	
	var Diagram = _styledComponents2.default.div(_templateObject4, function (props) {
	  return 'url(' + props.image + ')';
	});
	
	var LongForm = _styledComponents2.default.div(_templateObject5);
	
	var Author = _styledComponents2.default.div(_templateObject6);
	
	var Avatar = _styledComponents2.default.div(_templateObject7, 'url(' + _authorMike2.default + ')');
	
	var VideoWrapper = _styledComponents2.default.div(_templateObject8);
	
	var BlogPage = function BlogPage() {
	  return _react2.default.createElement(
	    Wrapper,
	    null,
	    _react2.default.createElement(_reactHelmet2.default, { title: 'Make the Right Connections | CommCards' }),
	    _react2.default.createElement(
	      _Grid2.default.Container,
	      null,
	      _react2.default.createElement(
	        LongForm,
	        null,
	        _react2.default.createElement(
	          'h2',
	          null,
	          'Using CommCards Series - Part 1'
	        ),
	        _react2.default.createElement(
	          'h1',
	          null,
	          'Make the Right Connections'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'We\u2019re excited about the upcoming launch of CommCards at the end of the month! To let you know what we\u2019re about, we\u2019re going to post examples of how the app can help make networking effortless.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'In this case, let\u2019s take for example Laura, a professional in search of a future collaborator. Laura can use CommCards to help make it easier to find who she wants to connect with nearby.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Laura wants to find a local designer for a new project involving an urban development initiative, but is having a hard time finding someone who best fits the situation. It can be challenging to find the right person to collaborate with if you don\u2019t have any recommendations or if you want to look for someone new to work with, especially locally.'
	        ),
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Here\u2019s how she can easily use CommCards in her search:'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Laura quickly searches the CommCards network for a designer in her city.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'By using the search bar, she can quickly search for job titles, locations, names, or any keywords to narrow in on suggested connections.'
	        ),
	        _react2.default.createElement(
	          VideoWrapper,
	          null,
	          _react2.default.createElement('iframe', { src: 'https://player.vimeo.com/video/273520194', autoplay: '1', width: '400', height: '710', frameborder: '0', allowfullscreen: true })
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Laura doesn\'t have any of the designers from her search results in her current network, but she views their profiles and hits \u201Cconnect\u201D to add them. Once they connect with her, she chats with them right away.'
	        ),
	        _react2.default.createElement(
	          VideoWrapper,
	          null,
	          _react2.default.createElement('iframe', { src: 'https://player.vimeo.com/video/273520297', autoplay: '1', width: '400', height: '710', frameborder: '0', allowfullscreen: true })
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'It looks like Laura found her collaborator! She quickly connected with a designer who has like-minded interests and started the conversation right away.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'CommCards provides valuable matchmaking suggestions so that you can connect with the right people. That means that you don\u2019t have to waste any time on your search. You\u2019re only one-click away from meeting the right person.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Now you have a sense of how CommCards can help you expand your network. Explore more of what CommCards has to offer with next week\u2019s post! '
	        )
	      )
	    )
	  );
	};
	
	exports.default = BlogPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-blog-using-commcards-make-the-right-connections-js-e889ffb678f6ffaf213b.js